import { Icon, Tooltip } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

import { getSystemIcon } from '@hotjar/webapp/utils/icons';

interface SystemIconProps {
  system: string;
}

export function SystemIcon({ system }: SystemIconProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'feedback-card.os' });
  return (
    <Tooltip text={system}>
      <Icon description={t('os-icon-description')} icon={getSystemIcon(system)} />
    </Tooltip>
  );
}
